import IssueItemNames from "../../mixins/item-name-list-search";
import AreaNames from "../../mixins/area-name-list-search";

Vue.component("issue-list", {

    mixins: [IssueItemNames, AreaNames],

    props: ["ticket_id"],

    data () {
        return {
            form: new AppForm({
                ticket_id: this.ticket_id,
                required_action: "No Action"
            }),
            bulkUpdateForm: new AppForm({
                headerCheckbox: false,
                selectedIssues: []
            }),
            editForm: new AppForm({}),
            selectedIssue: {},
            isLoadingIssues: true,
            allIssues: [],
            visibleIssues: [],
            expanded: false,
            showPhotosPanel: false,
            actionTypes: [
                "No Action",
                "Quote",
                "Proceed As Quoted",
                "Observe & Comment",
                "Attend On Call Out",
                "Completed"
            ],
        };
    },

    mounted () {
        this.resetBulkUpdateForm();
        this.fetchIssues();
        let self = this;
        Bus.$on("first-photo-uploaded", function (photoUrl) {
            self.selectedIssue.photo = photoUrl;
        });

        Bus.$on("issues-updated", function () {
            self.fetchIssues();
        });
    },

    computed: {

        selectedIssueId () {
            if (this.selectedIssue) {
                return this.selectedIssue.id;
            }
            return null;
        },

        issueCount () {
            return this.allIssues.length;
        },

        expandText () {
            if (this.expanded === false) {
                return "view " + (this.allIssues.length - 5) + " more";
            } else {
                return "only first 5";
            }
        },

        photoGalleryUrl () {
            if (_.isEmpty(this.selectedIssue)) {
                return "";
            }
            return "/tickets/issues/" + this.selectedIssue.id + "/photos";
        },

        photoUploadActionUrl () {
            return "/tickets/issues/" + this.selectedIssue.id + "/photos/upload";
        },

        photoGalleryTitle () {
            return _.isEmpty(this.selectedIssue) ? "Photos" : this.selectedIssue.item + " photos";
        },
    },

    watch: {
        allIssues: function (oldArray, newArray) {
            this.this = newArray;
            this.setVisibleIssues();
        },

        expanded: function () {
            this.setVisibleIssues();
        },
    },

    methods: {
        setVisibleIssues () {
            if (!this.expanded) {
                this.visibleIssues = this.allIssues.slice(0, 5);
            } else {
                this.visibleIssues = this.allIssues;
            }
        },

        toggleAllIssues () {
            this.expanded = !this.expanded;
        },

        bulkUpdateIssues (requiredAction) {
            this.bulkUpdateForm.required_action = requiredAction;
            App.post("/tickets/" + this.ticket_id + "/issues/update/bulk", this.bulkUpdateForm)
            .then((response) => {
                response.forEach(issue => {
                    let index = this.allIssues.findIndex(i => i.id === issue.id);
                    this.allIssues.splice(index, 1, issue);
                    this.setVisibleIssues();
                    Bus.$emit("issues-updated");
                });
                toastr.success(this.bulkUpdateForm.selectedIssues.length + " issues updated!");
                this.resetBulkUpdateForm();
            }).catch((errors) => {
                toastr.error("Could not update selected issues");
            });
        },

        resetBulkUpdateForm () {
            this.bulkUpdateForm = new AppForm({
                required_action: "Select Action",
                selectedIssues: []
            });
        },

        toggleFullSelection () {
            this.selectIssues(this.bulkUpdateForm.headerCheckbox == true ? "all" : "none");
        },

        selectIssues (option) {
            if (option === "all") {
                this.bulkUpdateForm.selectedIssues = this.allIssues.map(issue => issue.id);
                this.expanded = true;
            } else if (option === "none") {
                this.bulkUpdateForm.selectedIssues = [];
            }
        },

        showIssueCreateForm () {
            $("#modal-issue-create-form").modal("show");
        },

        hideIssueCreateForm () {
            $("#modal-issue-create-form").modal("hide");
        },

        showBulkUpdateModal () {
            if (this.bulkUpdateForm.selectedIssues.length <= 0) {
                toastr.error("You haven't selected any issues to update!");
            }
        },

        showIssueEditForm (issue) {
            this.editForm = new AppForm({
                issue_id: issue.id,
                item: issue.item,
                location: issue.location,
                description: issue.description,
                required_action: issue.required_action
            });

            $("#modal-issue-edit-form").modal("show");
        },

        hideIssueEditForm () {
            $("#modal-issue-edit-form").modal("hide");
        },

        cancelIssueCreateForm () {
            this.hideIssueCreateForm();
            this.form = new AppForm({
                ticket_id: this.ticket_id
            });
        },

        fetchIssues () {
            this.isLoadingIssues = true;
            axios.get("/tickets/" + this.ticket_id + "/issues/all", ({
                params: {}
            })).then(response => {
                Bus.$emit("issue-list-loaded");
                this.allIssues = response.data;
                this.isLoadingIssues = false;
            }).catch(() => {
                this.isLoadingIssues = false;
                toastr.error("Error retrieving issues!");
            });
        },

        createNewIssue () {
            App.post("/issues/create", this.form)
            .then((response) => {
                Bus.$emit("issues-updated");
                Bus.$emit("update-ticket-description");
                this.cancelIssueCreateForm();
                toastr.success("New Issue Created");
            }).catch((errors) => {
                toastr.error("Failed to create new Issue!");
            });
        },

        showDeleteConfirmation (issueId) {
            let self = this;
            swal({
                title: "Delete this issue?",
                showCancelButton: true
            }).then((result) => {
                if (result.value) {
                    self.deleteIssue(issueId);
                }
            });
        },

        deleteIssue (issueId) {
            if (this.issueIsSelected(issueId)) {
                this.toggleIssueSelection(issueId);
            }
            App.delete("/issues/" + issueId + "/delete", new AppForm({}))
            .then((response) => {
                Bus.$emit("issues-updated");
                Bus.$emit("update-ticket-description");
                if (response.detachMaintenanceRequestIds && response.detachMaintenanceRequestIds.length > 0) {
                    this.$emit("detach-maintenance-requests", response.detachMaintenanceRequestIds);
                }
                toastr.success(response.message);
            }).catch((error) => {
                toastr.error("Could not delete Issue! Error: " + error.data.message);
            });
        },

        updateIssue () {
            App.patch("/issues/" + this.editForm.issue_id + "/update", this.editForm)
            .then((response) => {
                Bus.$emit("issues-updated");
                Bus.$emit("update-ticket-description");
                this.hideIssueEditForm();
                toastr.success("Issue Updated");
            }).catch((errors) => {
                toastr("Could not update issue!");
            });
        },

        updateRequiredAction (requiredAction, issueId) {
            App.patch("/issues/" + issueId + "/updateAction", new AppForm({
                required_action: requiredAction
            })).then(() => {
                Bus.$emit("issues-updated");
                toastr.success("Issue Updated");
            });
        },

        toggleIssuePhotosPanel (issue) {
            if (!issue) {
                this.showPhotosPanel = !this.showPhotosPanel;
                return;
            }

            this.selectedIssue = issue;
            this.showPhotosPanel = true;
        },

        issueIsSelected (issueId) {
            return this.bulkUpdateForm.selectedIssues.indexOf(issueId) !== -1;
        },

        toggleIssueSelection (issueId) {
            let index = this.bulkUpdateForm.selectedIssues.indexOf(issueId);
            if (index === -1) {
                this.bulkUpdateForm.selectedIssues.push(issueId);
            } else {
                this.bulkUpdateForm.selectedIssues.splice(index, 1);
            }
        },
    },
});
